import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as userAccountActions from '../../actions/userAccount/userAccountActions';
import './LoginPage.css';
import toastr from 'toastr';

class LoginPage extends Component {
    constructor(props, context) {
        super(props, context);
        this.props.actions.logout();
        this.state = {
            username: "",
            password: "",
            loggedIn: false,
        };
        this.onUsernameChange = this.onUsernameChange.bind(this);
        this.onPasswordChange = this.onPasswordChange.bind(this);
        this.handleLogin = this.handleLogin.bind(this);
    }

    onUsernameChange(event) {
        this.setState({ username: event.target.value });
    }

    onPasswordChange(event) {
        this.setState({ password: event.target.value });
    }

    async handleLogin(e) {
        e.preventDefault();
        const { username, password } = this.state;
        if (username.length > 0 && password.length > 0) {
            const user = await this.props.actions.login(username, password);
            if (user) {
                this.props.history.push('/home');
            }
            else
            {
                toastr.error("Invalid Username or Password");
            }
        }
        else
            {
                toastr.error("Invalid Username or Password");
            }
    }

    render() {
        const { username, password } = this.state;
        const isEnabled =
            username.length > 0 &&
            password.length > 0;
        return (
            <div className="login-container">
                <div className="login">
                    <form>
                        <div className="login-form">
                            <label htmlFor="username">UserName</label>
                            <input id="username" type="text" placeholder="Enter your Email" onChange={(event) => this.onUsernameChange(event)} />
                            <label htmlFor="password">Password</label>
                            <input id="password" type="password" placeholder="Enter your Password" onChange={(event) => this.onPasswordChange(event)} />
                            <button className="login-form-button" type="submit" onClick={(e) => this.handleLogin(e)}
                                disabled={!isEnabled}>Login</button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

LoginPage.propTypes = {
    actions: PropTypes.object.isRequired,
    history: PropTypes.object
}

LoginPage.contextTypes = {
    router: PropTypes.object
}

export function mapStateToProps(state) {
    return {
        username: state.userAccount.username
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userAccountActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);